export const messages = {
  en: {
    repairPoolManage: {
      queryConditions: 'Query Conditions',
      repairOrderPool: 'Repair List',
      workOrderCode: 'Work Order Code',
      location: 'Location',
      repairType: 'Repair Type',
      maintenanceType: 'Maintenance Type',
      repairPerson: 'Repair Person',
      contact: 'Contact',
      appointmentTime: 'Appointment Time',
      submissionTime: 'Submission Time',
      submissionDuration: 'Submission Duration',
      completionTime: 'Completion Time',
      status: 'Status',
      operation: 'Operation',
      modify: 'Modify',
      dispatch: 'Dispatch',
      grabOrder: 'Grab Order',
      end: 'End',
      details: 'Details',
      preview: 'Preview',
      delete: 'Delete',
      search: 'Search',
      reset: 'Reset',
      more: 'More',
      hide: 'Hide',
      all: 'All',
      timeoutOrders: 'Timeout Orders',
      indoorRepair: 'Indoor Repair',
      publicAreaRepair: 'Public Area Repair',
      staffRepair: 'Staff Repair',
      tabMyCreated: 'My Created',
      tabPending: 'Pending',
      tabProcessed: 'Processed',
      selectTabType: 'Select Type',
      switchRole: 'Switch Role',
      roleDefault: 'Please Select',
      roleEmpty: 'No Roles',
      workOrderCodePlaceholder: 'Work Order Code',
      repairPersonPlaceholder: 'Repair Person',
      statusPlaceholder: 'Status',
      workOrderNumber: 'Work Order Number',
      repairPersonName: 'Repair Person Name',
      repairPhone: 'Repair Phone',
      selectRepairType: 'Select Repair Type',
      selectRepairSettingType: 'Select Repair Setting Type',
      repairLocation: 'Repair Location',
      selectMaintenanceType: 'Select Maintenance Type',
      startTime: 'Start Time',
      endTime: 'End Time',
      repairSettingType: 'Repair Setting Type',
      repairContent: 'Repair Content',
      operationSuggestions: 'Operation Suggestions',
      endReason: 'End Reason',
      paidService: 'Paid Service',
      freeService: 'Free Service',
      needMaterials: 'Need Materials',
      noMaterialsNeeded: 'No Materials Needed',
      timedTaskProcessing: 'Timed Task Processing'
    }
  },
  zh: {
    repairPoolManage: {
      queryConditions: '查询条件',
      repairOrderPool: '报修列表',
      workOrderCode: '工单号',
      location: '位置',
      repairType: '报修类型',
      maintenanceType: '维修类型',
      repairPerson: '报修人',
      contact: '联系方式',
      appointmentTime: '报修时间',
      submissionTime: '提交时间',
      submissionDuration: '提单时长',
      completionTime: '完成时间',
      status: '状态',
      operation: '操作',
      modify: '修改',
      dispatch: '派单',
      grabOrder: '抢单',
      end: '结束',
      details: '详情',
      preview: '预览',
      delete: '删除',
      search: '查询',
      reset: '重置',
      more: '更多',
      hide: '隐藏',
      all: '全部',
      timeoutOrders: '超时工单',
      indoorRepair: '室内报修',
      publicAreaRepair: '公区报修',
      staffRepair: '员工报修',
      tabMyCreated: '我发起的',
      tabPending: '未处理',
      tabProcessed: '已处理',
      selectTabType: '请选择',
      switchRole: '切换角色',
      roleDefault: '请选择',
      roleEmpty: '暂无角色',
      workOrderCodePlaceholder: '请输入工单编号',
      repairPersonPlaceholder: '请输入报修人',
      statusPlaceholder: '请选择工单状态',
      workOrderNumber: '工单编号',
      repairPersonName: '报修人',
      repairPhone: '报修电话',
      selectRepairType: '请选择报修类型',
      selectRepairSettingType: '请选择报修设置类型',
      repairLocation: '报修位置',
      selectMaintenanceType: '请选择维修类型',
      startTime: '开始时间',
      endTime: '结束时间',
      repairSettingType: '报修设置类型',
      repairContent: '报修内容',
      operationSuggestions: '说明',
      endReason: '结束原因',
      paidService: '付费服务',
      freeService: '免费服务',
      needMaterials: '需要材料',
      noMaterialsNeeded: '不需要材料',
      timedTaskProcessing: '定时任务处理中'
    }
  }
}